import React, { useEffect, useState } from 'react';
import styles from './AdminBoard.module.css';
import StorageDiagram from '../../components/StorageGrid/StorageDiagram';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import { useNavigate } from 'react-router-dom'

const AdminBoard = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    const token = localStorage.getItem('access_token');

    if(!token) {
      navigate('/login');
    }
  }, [navigate])
  
  const initialUnits = [
    { unit: "1", size: "10x30", name: "", notes: "" },
    { unit: "2", size: "10x30", name: "", notes: "" },
    { unit: "3", size: "10x30", name: "", notes: "" },
    { unit: "4", size: "10x30", name: "", notes: "" },
    { unit: "5", size: "10x30", name: "", notes: "" },
    { unit: "6", size: "10x30", name: "", notes: "" },
    { unit: "7", size: "10x30", name: "", notes: "" },
    { unit: "8", size: "10x15", name: "", notes: "" },
    { unit: "9", size: "10x15", name: "", notes: "" },
    { unit: "10", size: "10x15", name: "", notes: "" },
    { unit: "11", size: "10x15", name: "", notes: "" },
    { unit: "12", size: "10x30", name: "", notes: "" },
    { unit: "13", size: "10x30", name: "", notes: "" },
    { unit: "14", size: "10x30", name: "", notes: "" },
    { unit: "15", size: "10x30", name: "", notes: "" },
    { unit: "16", size: "10x30", name: "", notes: "" },
    { unit: "17", size: "10x30", name: "", notes: "" },
    { unit: "18", size: "10x30", name: "", notes: "" },
    { unit: "19", size: "10x10", name: "", notes: "" },
    { unit: "20", size: "10x10", name: "", notes: "" },
    { unit: "21", size: "10x10", name: "", notes: "" },
    { unit: "22", size: "10x10", name: "", notes: "" },
    { unit: "23", size: "10x10", name: "", notes: "" },
    { unit: "24", size: "10x10", name: "", notes: "" },
    { unit: "25", size: "10x10", name: "", notes: "" },
    { unit: "26", size: "10x10", name: "", notes: "" },
    { unit: "27", size: "10x10", name: "", notes: "" },
    { unit: "28", size: "10x10", name: "", notes: "" },
    { unit: "29", size: "10x10", name: "", notes: "" },
    { unit: "30", size: "10x10", name: "", notes: "" },
    { unit: "31", size: "10x10", name: "", notes: "" },
    { unit: "32", size: "10x10", name: "", notes: "" },
    { unit: "33", size: "10x10", name: "", notes: "" },
    { unit: "34", size: "10x10", name: "", notes: "" },
    { unit: "35", size: "10x10", name: "", notes: "" },
    { unit: "36", size: "10x10", name: "", notes: "" }
  ];

  const [tableData, setTableData] = useState(initialUnits);
  const [showSaved, setShowSaved] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const response = await fetch("https://377storage.vip/api/admin-board", {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
          },
        });

        if (!response.ok) {
          const errorMessage = await response.json();
          console.error("Error details:", errorMessage);
          throw new Error('Failed to save admin board data');
        }

        const dbUnits = await response.json();

        const mergedData = initialUnits.map(unit => {
          const savedUnit = dbUnits.find(u => String(u.number) === String(unit.unit));
          return savedUnit
            ? { ...unit, name: savedUnit.name || "", notes: savedUnit.notes || "" }
            : unit;
        });

        setTableData(mergedData);
      } catch (error) {
        console.error("Error fetching admin board data:", error.message);
      }
    };

    fetchUnits();
  }, []);

  const handleChange = (index, field, value) => {
    const newData = [...tableData];
    newData[index][field] = value;
    setTableData(newData);
  };

  const saveChanges = async () => {
    try {
      const response = await fetch('https://377storage.vip/api/admin-board', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(tableData.map(unit => ({ number: unit.unit, name: unit.name, notes: unit.notes }))),
      });

      if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error('Failed to save admin board data');
      }

      setShowSaved(true);
      setTimeout(() => setShowSaved(false), 2000);
    } catch (error) {
      console.error('Error saving admin board data:', error);
      setShowError(true);
      setTimeout(() => setShowError(false), 2500);
    }
  };

  const popupStyle = {
    position: 'fixed',
    top: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '14px 28px',
    borderRadius: '10px',
    color: '#fff',
    fontWeight: 600,
    fontFamily: 'Arial, sans-serif',
    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
    zIndex: 9999,
  };

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <DashboardHeader />

      {/* Saved popup */}
      {showSaved && (
        <div style={{ ...popupStyle, background: '#22c55e' }}>
          Saved!
        </div>
      )}

      {/* Error popup */}
      {showError && (
        <div style={{ ...popupStyle, background: '#ef4444' }}>
          There was an error saving data. Please try again.
        </div>
      )}

      {/* Blurred background */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "url('/images/iStock-907888472.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(8px)',
          zIndex: 1,
        }}
      />

      <div className={styles.container} style={{ position: 'relative', zIndex: 2 }}>
        <table className={styles.storageTable}>
          <thead>
            <tr>
              <th>Unit # | Size</th>
              <th>Name</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((unit, index) => (
              <tr key={unit.unit}>
                <td style={{ fontFamily: 'Arial, sans-serif', fontWeight: 'bold' }}>{unit.unit} | {unit.size}</td>
                <td>
                  <input
                    type="text"
                    value={unit.name}
                    placeholder="Vacant"
                    onChange={(e) => handleChange(index, 'name', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={unit.notes}
                    placeholder="Enter notes"
                    onChange={(e) => handleChange(index, 'notes', e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <button className={styles.saveButton} onClick={saveChanges}>
          Save Changes
        </button>

        <StorageDiagram
          tableData={tableData}
          setTableData={setTableData}
          units={tableData.reduce((acc, unit) => {
            acc[unit.unit] = { renterName: unit.name || "" };
            return acc;
          }, {})}
        />
      </div>
    </div>
  );
};

export default AdminBoard;